var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFlagIndia = function SvgFlagIndia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 251 175",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f93",
    d: "M0 0h225v150H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 50h225v50H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M0 100h225v50H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.5 70)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FlagIndia_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FlagIndia_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FlagIndia_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FlagIndia_svg__a",
    fill: "#008"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.875,
    transform: "rotate(7.5 -8.75 133.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5L.6 7 0 2l-.6 5L0 17.5z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagIndia_svg__a",
    transform: "rotate(15)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagIndia_svg__b",
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagIndia_svg__c",
    transform: "rotate(60)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagIndia_svg__d",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagIndia_svg__d",
    transform: "rotate(-120)"
  }))));
};
export default SvgFlagIndia;